import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useKycSubmittedTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackKycSubmitted = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
      });
    },
    [trackEvent],
  );

  const trackSelectKycSurvey = useCallback(
    (eventName: TrackingEvent, title: string, answer: string) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        Survey: {
          title,
          answer,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackKycSubmitted,
    trackSelectKycSurvey,
  };
};
